module.exports = __webpack_public_path__ + "static/media/externalBarn_1.d8955752.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/barn/externalBarn_1.png
// module id = 1297
// module chunks = 3